// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  dev: {
    "aws_appsync_graphqlEndpoint": "https://5fzg653wzrdcpg2kvg7nljeh64.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wsi5yfvtmnbxfbhi3odxntslgm"
  },
  main: {
    "aws_appsync_graphqlEndpoint": "https://aitjmbzhsbagnbysj2jrinbrsq.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-zlk3xmy44fg4jpj73vlwlfi7sq"
  },
  cn: {
    "aws_appsync_graphqlEndpoint": "https://ger6guaiyjdkxppfix5gd6fyqm.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qdnwvb7tk5bmhbon2wvx2mgvlu"
  }
}

export default awsmobile;
